var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c("p", {}, [_vm._v("頁面編輯")]),
      _c(
        "select",
        { staticClass: "form-control", on: { change: _vm.clickButton2 } },
        _vm._l(_vm.buttons, function(button, index) {
          return _c(
            "option",
            { key: index, domProps: { value: button.SystemId } },
            [_vm._v(_vm._s(button.Text))]
          )
        }),
        0
      ),
      _c("DLGButtonEdit", {
        ref: "dlgEditor",
        on: { returnOk: _vm.dlgEditorReturnOK }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }